'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analytics = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _analytics;

exports.default = reducer;
exports.closeToast = closeToast;
exports.closeNotiVerify = closeNotiVerify;
exports.openNotiVerify = openNotiVerify;
exports.logClickToast = logClickToast;
exports.pushNotification = pushNotification;
exports.pushRedeemReminder = pushRedeemReminder;
exports.pushInstant = pushInstant;
exports.pushVerifyEmail = pushVerifyEmail;
exports.pushNotiVerify = pushNotiVerify;
exports.toastOAuthLoginSuccess = toastOAuthLoginSuccess;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _translations = require('json/translations.json');

var _translations2 = _interopRequireDefault(_translations);

var _constant = require('redux/modules/booking/constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_TOAST = 'redux-frontend/toast/CLOSE_TOAST';
var CLOSE_NOTI_VERIFY = 'redux-frontend/toast/CLOSE_NOTI_VERIFY';
var OPEN_NOTI_VERIFY = 'redux-frontend/toast/OPEN_NOTI_VERIFY';
var PUSH_TOAST = 'redux-frontend/toast/PUSH_TOAST';
var PUSH_REDEEM_REMINDER = 'redux-frontend/toast/PUSH_REDEEM_REMINDER';
var PUSH_INSTANT = 'redux-frontend/toast/PUSH_INSTANT';
var PUSH_VERIFY_EMAIL = 'redux-frontend/toast/PUSH_VERIFY_EMAIL';
var PUSH_NOTI_VERIFY = 'redux-frontend/toast/PUSH_NOTI_VERIFY';
// const DUMP_TRANSLATED_MESSAGES = 'redux-frontend/toast/DUMP_TRANSLATED_MESSAGES';
var CLICK_TOAST = 'redux-frontend/toast/CLICK_TOAST';

var LOGIN_SUCCESS = 'redux-frontend/session/LOGIN_SUCCESS';
var UPDATE_PROFILE_SUCCESS = 'redux-frontend/profile/UPDATE_PROFILE_SUCCESS';
var UPDATE_BOOKING_SUCCESS = 'redux-frontend/booking/UPDATE_BOOKING_SUCCESS';
var CONFIRM_BOOKING_SUCCESS = 'redux-frontend/booking/CONFIRM_BOOKING_SUCCESS';
var RESCHEDULE_BOOKING_SUCCESS = 'redux-frontend/booking/RESCHEDULE_BOOKING_SUCCESS';
var RESCHEDULE_BOOKING_FAIL = 'redux-frontend/booking/RESCHEDULE_BOOKING_FAIL';
var RESPOND_BOOKING_SUCCESS = 'redux-frontend/booking/RESPOND_BOOKING_SUCCESS';
var UPDATE_LISTING_SUCCESS = 'redux-frontend/listing/UPDATE_LISTING_SUCCESS';
var SUBMIT_LISTING_SUCCESS = 'redux-frontend/listing/SUBMIT_LISTING_SUCCESS';
var SEND_SMS_SUCCESS = 'redux-frontend/session/SEND_SMS_SUCCESS';
var CONFIRM_MOBILE_SUCCESS = 'redux-frontend/session/CONFIRM_MOBILE_SUCCESS';
var SEND_EMAIL_SUCCESS = 'redux-frontend/profile/SEND_EMAIL_SUCCESS';
var SAVE_AVAIL_SUCCESS = 'redux-frontend/availability/SAVE_AVAIL_SUCCESS';
var DUPLICATE_LISTING_SUCCESS = 'redux-frontend/listing/DUPLICATE_LISTING_SUCCESS';
var SUBMIT_LX_CANCEL_SUCCESS = 'redux-frontend/booking/SUBMIT_LX_CANCEL_SUCCESS';
var REQUST_SUGGESTED_TRIP_SUCCESS = 'redux-frontend/booking/REQUST_SUGGESTED_TRIP_SUCCESS';
// const SUBMIT_CUSTOMIZE_SUCCESS = 'redux-frontend/customize/SUBMIT_SUCCESS';
var COPY_LINK_SUCCESS = 'redux-frontend/trip/COPY_LINK_SUCCESS';
// const SHARE_FB = 'redux-frontend/session/SHARE_FB';
var REPLY_REVIEW_SUCCESS = 'redux-frontend/booking/REPLY_REVIEW_SUCCESS';
// const SUBMIT_PEER_REVIEW_SUCCESS = 'redux-frontend/trip/SUBMIT_PEER_REVIEW_SUCCESS';

var LOAD_COMBINED_STATIC_SUCCESS = 'redux-frontend/info/LOAD_COMBINED_STATIC_SUCCESS';
var SUBMIT_PAYMENT_CODE_SUCCESS = 'redux-frontend/booking/SUBMIT_PAYMENT_CODE_SUCCESS';
var UPLOAD_TRIP_IMAGE = 'redux-frontend/booking/UPLOAD_TRIP_IMAGE';

var RELEASE_PAYMENT_SUCCESS = 'redux-frontend/booking/RELEASE_PAYMENT_SUCCESS';
var HOLD_PAYMENT_SUCCESS = 'redux-frontend/booking/HOLD_PAYMENT_SUCCESS';
var OAUTH_LOGIN_SUCCESS = 'redux-frontend/session/OAUTH_LOGIN_SUCCESS';

var CUSTOMIZE_QTY = 'redux-frontend/customize/CUSTOMIZE_QTY';
var SUBMIT_INSURANCES_SUCCESS = 'redux-frontend/payment/SUBMIT_INSURANCES_SUCCESS';

var POST_MANUAL_REVIEW_SUCCESS = 'redux-frontend/review/POST_SUCCESS';
// const SUBMIT_DIGI = 'redux-frontend/digi/SUBMIT';

// const SET_PAYMENT_FAIL = 'redux-frontend/booking/SET_PAYMENT_FAIL';

var toastCounter = 0;

var initialState = {
  show: false,
  message: '',
  type: '',
  // toasts: [
  //   {
  //     message: 'You have fail this city!! You have fail this city!! You have fail this city!!',
  //     type: 'error',
  //   }, {
  //     message: 'You have fail this city!!',
  //     type: 'warning',
  //   }, {
  //     message: 'You have fail this city!!',
  //     type: 'success',
  //   }
  // ],
  toasts: [],
  instantPushed: false,
  verifyEmailPushed: false,
  messages: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var locale = action.locale || 'en';
  switch (action.type) {
    case CLOSE_TOAST:
      var index = _lodash2.default.findIndex(state.toasts, { id: action.id });
      if (index < 0) {
        return state;
      }
      var toasts = [].concat((0, _toConsumableArray3.default)(state.toasts.slice(0, index)), [(0, _extends3.default)({}, state.toasts[index], { closed: true })], (0, _toConsumableArray3.default)(state.toasts.slice(index + 1)));
      return (0, _extends3.default)({}, state, {
        toasts: toasts
      });
    case CLOSE_NOTI_VERIFY:
      var indexNotiVerify = _lodash2.default.findIndex(state.toasts, { id: action.id });
      if (indexNotiVerify < 0) {
        return state;
      }
      var toastsNotiVerify = [].concat((0, _toConsumableArray3.default)(state.toasts.slice(0, indexNotiVerify)), [(0, _extends3.default)({}, state.toasts[indexNotiVerify], { closedNoti: true })], (0, _toConsumableArray3.default)(state.toasts.slice(indexNotiVerify + 1)));
      return (0, _extends3.default)({}, state, {
        toasts: toastsNotiVerify
      });
    case OPEN_NOTI_VERIFY:
      var indexOpen = _lodash2.default.findIndex(state.toasts, { id: action.id });
      if (indexOpen < 0) {
        return state;
      }
      var openToasts = [].concat((0, _toConsumableArray3.default)(state.toasts.slice(0, indexOpen)), [(0, _extends3.default)({}, state.toasts[indexOpen], { closedNoti: false })], (0, _toConsumableArray3.default)(state.toasts.slice(indexOpen + 1)));
      return (0, _extends3.default)({}, state, {
        toasts: openToasts
      });
    // case DUMP_TRANSLATED_MESSAGES:
    //   return {
    //     ...state,
    //     messages: action.messages
    //   };
    case LOAD_COMBINED_STATIC_SUCCESS:
      // const translations = action.result.translations;
      // const locale = action.locale || 'en';
      var toastMessages = (0, _keys2.default)(_translations2.default).filter(function (k) {
        return k.startsWith('toast');
      });
      return (0, _extends3.default)({}, state, {
        messages: _lodash2.default.pick(_translations2.default[locale], toastMessages)
      });
    case CONFIRM_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.booking_confirmed'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case CONFIRM_MOBILE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.mobile_verified'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case DUPLICATE_LISTING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.listing_duplicated'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case LOGIN_SUCCESS:
    case OAUTH_LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.logged_in'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case RESCHEDULE_BOOKING_SUCCESS:
      var resMessage = !action.days || action.days.length < 1 ? _translations2.default[locale]['toast.trip_canceled'] : _translations2.default[locale]['toast.booking_rescheduled'];
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: resMessage, type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case RESCHEDULE_BOOKING_FAIL:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: action.error.message, type: 'warning', timeout: 3000, id: String(++toastCounter) }])
      });
    case RESPOND_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: action.date ? _translations2.default[locale]['toast.new_trip_date_selected'] : _translations2.default[locale]['toast.trip_canceled'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case REQUST_SUGGESTED_TRIP_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.request_sent'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case SAVE_AVAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.availability_updated'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case SEND_EMAIL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.confirm_email_sent'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case SEND_SMS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.sms_sent'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case SUBMIT_LX_CANCEL_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.trip_canceled'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    // case SUBMIT_CUSTOMIZE_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: 'Submitted, we will contact you as soon as posible.', type: 'success', timeout: 7000, id: String(++toastCounter)}]
    //   };
    case UPDATE_PROFILE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.profile_updated'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case UPDATE_BOOKING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: action.noToast ? state.toasts : [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.trip_updated'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case UPDATE_LISTING_SUCCESS:
      if (action.hideToast) return state;
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.save_draft'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case SUBMIT_LISTING_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.submit_listing'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case UPLOAD_TRIP_IMAGE:
    case SUBMIT_PAYMENT_CODE_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: 'Successfully submitted', timeout: 3000, id: String(++toastCounter) }])
      });
    case RELEASE_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: 'Payment released, please help us give a review.', timeout: 3000, id: String(++toastCounter) }])
      });
    case HOLD_PAYMENT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: 'Payment has been held, we will contact you shortly.', timeout: 3000, id: String(++toastCounter) }])
      });
    case _constant.POST_REVIEW_SUCCESS:
    case POST_MANUAL_REVIEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: 'Thank you for your review', timeout: 3000, id: String(++toastCounter) }])
      });
    case CUSTOMIZE_QTY:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: 'You’re sending a booking request. We’ll contact you back within 24 hours', type: 'success', timeout: 5000, id: String(++toastCounter) }])
      });
    case PUSH_TOAST:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: action.notification.text, type: 'noti',
          timeout: 5000, id: String(++toastCounter),
          sender_id: action.notification.sender_id,
          link: action.notification.path,
          is_admin: action.notification.type }])
      });
    case PUSH_REDEEM_REMINDER:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{
          type: 'redeem',
          timeout: 0,
          id: action.code,
          percentage: action.percentage,
          constant: action.constant,
          currency: action.currency,
          expires_at: action.expires_at,
          code: action.code
        }])
      });
    case COPY_LINK_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.copy_link'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    case PUSH_VERIFY_EMAIL:
      return (0, _extends3.default)({}, state, {
        verifyEmailPushed: true,
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.verify_email'], type: 'warning', timeout: 5000, id: String(++toastCounter), link: '/dashboard/verification' }])
      });
    case PUSH_NOTI_VERIFY:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{
          message: 'Uh-oh! Please verify yourself first,',
          type: 'noti-verify',
          id: String(++toastCounter),
          link: '/dashboard/verification'
        }])
      });
    case REPLY_REVIEW_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{ message: _translations2.default[locale]['toast.reply_review'], type: 'success', timeout: 3000, id: String(++toastCounter) }])
      });
    // case SUBMIT_DIGI:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: 'Form submitted', type: 'success', timeout: 3000, id: String(++toastCounter)}]
    //   };
    // case SUBMIT_PEER_REVIEW_SUCCESS:
    //   return {
    //     ...state,
    //     toasts: [...state.toasts, {message: 'Review submitted', type: 'success', timeout: 3000, id: String(++toastCounter)}]
    //   };
    case PUSH_INSTANT:
      return (0, _extends3.default)({}, state, {
        instantPushed: true,
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{
          type: 'instant',
          timeout: 0,
          id: String(++toastCounter)
        }])
      });
    case SUBMIT_INSURANCES_SUCCESS:
      return (0, _extends3.default)({}, state, {
        toasts: [].concat((0, _toConsumableArray3.default)(state.toasts), [{
          message: 'We have received your information for insurance.',
          type: 'success',
          timeout: 10000, id: String(++toastCounter)
        }])
      });
    default:
      return state;
  }
}

var analytics = exports.analytics = (_analytics = {}, (0, _defineProperty3.default)(_analytics, PUSH_REDEEM_REMINDER, function (action) {
  return { name: 'Push Info Toast', category: 'Toast', toastType: 'promo_code', code: action.code };
}), (0, _defineProperty3.default)(_analytics, PUSH_INSTANT, function () {
  return { name: 'Push Info Toast', category: 'Toast', toastType: 'instant_tomorrow' };
}), (0, _defineProperty3.default)(_analytics, CLICK_TOAST, function (action) {
  return { name: 'Click Toast', category: 'Toast', toastType: action.toastType, code: action.code };
}), _analytics);

function closeToast(id) {
  return {
    type: CLOSE_TOAST,
    id: id
  };
}
function closeNotiVerify(id) {
  return {
    type: CLOSE_NOTI_VERIFY,
    id: id
  };
}
function openNotiVerify(id) {
  return {
    type: OPEN_NOTI_VERIFY,
    id: id
  };
}
function logClickToast(toastType) {
  var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: CLICK_TOAST,
    toastType: toastType,
    code: code
  };
}
function pushNotification(notification) {
  return {
    type: PUSH_TOAST,
    notification: notification
  };
}

function pushRedeemReminder(redeem) {
  return {
    type: PUSH_REDEEM_REMINDER,
    code: redeem.code,
    percentage: redeem.percentage,
    constant: redeem.constant,
    currency: redeem.currency,
    expires_at: redeem.expires_at
  };
}

function pushInstant() {
  return {
    type: PUSH_INSTANT
  };
}

function pushVerifyEmail() {
  return {
    type: PUSH_VERIFY_EMAIL
  };
}

function pushNotiVerify() {
  return {
    type: PUSH_NOTI_VERIFY
  };
}

function toastOAuthLoginSuccess() {
  return {
    type: OAUTH_LOGIN_SUCCESS
  };
}

// export function dumpTranslatedMessages(messages) {
//   return {
//     type: DUMP_TRANSLATED_MESSAGES,
//     messages,
//   };
// }

// export function dumpTranslatedMessage(messages) {
//   return {
//     type: DUMP_TRANSLATED_MESSAGES,
//     messages
//   };
// }


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/toast.js
// module id = 197
// module chunks = 47